import React, { useEffect, useState } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import * as actions from '../actions';

import { VerifyEmailStyles } from './style';

import useQuery from 'reusable/customHooks/useQuery';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useVerifyEmailMutation } from 'services/api/ums';
import { connect } from 'react-redux';
import { isAuthorizedDomain } from '../helpers';
import useHeader from 'containers/App/Header/useHeader';

function VerifyEmailPage({ loginUser }) {
  useHeader('Verify Email');
  const [query] = useQuery();
  const history = useHistory();

  const [error, setError] = useState('');

  const token = query.get('token');
  const email = query.get('email');

  const [verifyEmail, verifyEmailState] = useVerifyEmailMutation();

  useEffect(() => {
    verifyEmail({ token, email });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (verifyEmailState.isError) {
      setError(get(verifyEmailState, 'error.data.message'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyEmailState.isError]);

  useEffect(() => {
    if (verifyEmailState.isSuccess) {
      toast.success(get(verifyEmailState, 'data.message'));
      loginUser({
        profileObj: {
          ...verifyEmailState.data,
          familyName: verifyEmailState.data.lastName,
          givenName: verifyEmailState.data.firstName,
          type: isAuthorizedDomain(verifyEmailState.data.email)
            ? 'internal'
            : 'external',
        },
        tokenId: verifyEmailState.data.accessToken,
        tokenType: 'UMS',
      });
      history.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyEmailState.isSuccess]);

  return (
    <VerifyEmailStyles>
      <Container fluid className="verify-email-container">
        {verifyEmailState.isLoading && (
          <>
            <Spinner animation="border" />
            <div className="status-text">verifying email</div>
          </>
        )}
        {error && <div className="error-message">{error}</div>}
      </Container>
    </VerifyEmailStyles>
  );
}

const mapDispatchToProps = dispatch => ({
  loginUser: data => dispatch(actions.loginUser(data)),
});

export default connect(null, mapDispatchToProps)(VerifyEmailPage);
